module.exports = __webpack_public_path__ + "img/logo-jaleko.a1651cdc.svg";